import { getIconForUID } from "components/FormerEditor/utils";
import ZoneLink from "components/ZoneLink";
import { HUB_DEV_SETTINGS } from "constants/docs";
import React from "react";

const ZoneIconLink = ({
  href = HUB_DEV_SETTINGS,
  copy = "Dashboard",
  icon = "rightArrow"
}) => {
  const Icon = getIconForUID(icon);

  return (
    <ZoneLink href={href}>
      <div className="flex flex-row color-primary pointer">
        <div className="f5 fw6 link__decoration--hover">{copy}</div>
        <Icon size={18} />
      </div>
    </ZoneLink>
  );
};

export default ZoneIconLink;
